import { IconType } from "react-icons";
import SidebarItem, { SidebarItemProps } from "../sidebar-item";
import {
  AcordeonBody,
  AcordeonContainer,
  AcordeonHeader,
} from "./index.styled";
import { useCallback, useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

interface SidebarAcordeonProps {
  id: string;
  icon: IconType;
  label: string;
  itens: SidebarItemProps[];
  sidebarIsOpen: boolean;
  setSidebarIsOpen?: (isOpen: boolean) => void;
  selected?: boolean;
}
const SidebarAcordeon: React.FC<SidebarAcordeonProps> = ({
  id,
  icon: Icon,
  label,
  itens,
  sidebarIsOpen,
  setSidebarIsOpen,
  selected,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setIsOpen(!isOpen);
    setSidebarIsOpen && setSidebarIsOpen(true);
  }, [isOpen, setSidebarIsOpen]);

  return itens.length > 0 ? (
    <AcordeonContainer
      id={id}
      isOpen={sidebarIsOpen && isOpen}
      onClick={handleOpen}
    >
      <AcordeonHeader isOpen={sidebarIsOpen && isOpen} selected={!!selected}>
        <span id="title">
          <Icon />
          {label}
        </span>
        <span id="chevron-icon">
          {isOpen ? <FiChevronUp /> : <FiChevronDown />}
        </span>
      </AcordeonHeader>
      <AcordeonBody isOpen={sidebarIsOpen && isOpen}>
        {itens.map((item) => (
          <SidebarItem {...item} key={item.id} showFull={true} />
        ))}
      </AcordeonBody>
    </AcordeonContainer>
  ) : null;
};

export default SidebarAcordeon;
